import { GridTemplateType } from "../types";

export const getGridTemplateColumns = (columns: number, columnWidth: GridTemplateType) => {
    switch (columnWidth) {
        case "equal":
            return `repeat(${columns}, 1fr)`;
        case "auto":
            return `repeat(${columns}, auto)`;
        case "custom":
            if (columns === 1) return "1fr";
            if (columns === 2) return "2fr 1fr";
            if (columns === 3) return "2fr 1fr 1fr";
            if (columns === 4) return "2fr 1fr 1fr 1fr";
            return `2fr 1.5fr ${Array(columns - 2)
                .fill("1fr")
                .join(" ")}`;
        default:
            return `repeat(${columns}, 1fr)`;
    }
};

export const getGridTemplateRows = (rows: number, grow: boolean) => {
    if (rows <= 1) return "auto";
    return grow ? `repeat(${rows}, 1fr)` : `repeat(${rows}, auto)`;
};

export const generateZoneId = (rowIndex: number, colIndex: number) => {
    return `grid-cell-${rowIndex}-${colIndex}`;
};

export const ALLOWED_BLOCK_TYPES = [
    "Typography",
    "Space",
    "Separator",
    "Image",
    "HeroSection",
    "ArticlesSection",
    "IndicatorsSection",
    "ScoreChartBlock",
    "ActionPlan",
];
